/* file description */
import React, { useMemo, useRef, useState } from 'react';
import styles from '../../index.module.less';
import optionImages from './more.png';
import {
  Button,
  InfiniteScroll,
  List,
  Popover,
  Popup,
  Modal,
  Ellipsis,
  CenterPopup,
  Space,
} from 'antd-mobile';
import { RightOutlined } from '@ant-design/icons';
import { useChangeRow, useMbOptionColums } from '../../effect';
import { BetaSchemaForm, ProFormInstance } from '@cui/pro-components';
import { ItemView } from '../ItemView';
import { RowSelectionLayout, RowSelectionBox } from './RowSelectionLayout';
import { SPField, SPForm } from '@/components/SPForm';

const { Item } = List;

export const ListItem = ({
  listValue,
  mergeColumns,
  mergeOptionColumns,
  onRow,
  rowKey,
  rowValueChange,
  tableBaseMode,
  rowSelection,
  listTitle,
  mobileRows,
  selectedRows,
}) => {
  const isEdit = tableBaseMode === 'add' || tableBaseMode === 'edit';

  const [optionState, setOptionState] = useState({
    visible: false,
    ele: undefined,
  });

  const [editPopupVisible, setEditPopupVisible] = useState(false);
  const [viewPoupupVisible, setViewPoupupVisible] = useState(false);
  const [radioValue, setRadioValue] = useState(null);
  const rowFormRef = useRef<ProFormInstance>();
  // get row data index
  const clickRowIndex = useRef<number>();

  /**
   * 处理从上层传入的colums加入mobile的按钮
   * @mergeOptionColumns 从spwithmodel传如的colums
   */
  const { mbOptionColums } = useMbOptionColums({
    tableBaseMode,
    mergeOptionColumns,
    clickRowIndex,
    setEditPopupVisible,
    setOptionState,
  });
  /**
   * 编辑后弹框的保存
   */
  const { changeRow } = useChangeRow({
    rowFormRef,
    clickRowIndex,
    rowValueChange,
    setEditPopupVisible,
  });

  const showColumns = useMemo(() => {
    if (mobileRows.length === 0) {
      return ({
        titleColums: mergeColumns?.[0] || {},
        contentColums: mergeColumns?.slice?.(1, 4) || [],
      });
    }
    const titleColums = mergeColumns?.find((col) => col.dataIndex === mobileRows[0]) || {};
    const otherCols = mobileRows.slice(1, mobileRows.length);
    return ({
      titleColums,
      contentColums: mergeColumns?.filter((col) => {
        if (otherCols.includes(col.dataIndex)) {
          return true;
        }
        return false;
      }),
    });
  }, [mergeColumns, mobileRows]);

  const listValues = (Object.values(listValue).flat() || []);
  return (
    <>
      <RowSelectionBox
        rowSelection={rowSelection}
        rowKey={rowKey}
        selectedRows={selectedRows}
        listValues={listValues}
      >
        {listValues.map((item: any, index) => {
          // const titleColumn = mergeColumns?.[0] || {};
          // const cuColumns = mergeColumns?.slice?.(0, 3) || [];
          const contentItems = showColumns.contentColums.map((x: any) => {
            const { render, dataIndex, title, ...others } = x || {};
            return (
              <div className={styles['item-x-wrap']} key={dataIndex}>
                <div className={styles['item-x-label-wrap']}>{title} :</div>
                <div className={styles['item-content-text-wrap']}>
                  <SPField
                    rowIndex={index}
                    from="form"
                    key={index}
                    name={[x.dataIndex]}
                    render={x.render}
                    valueType={x.valueType}
                    formItemProps={x.formItemProps}
                    fieldProps={x.fieldProps}
                    style={{ marginBottom: 0 }}
                    formValue={item}
                    mode="read"
                  />
                </div>
              </div>
            );
          });
          const onEvents = onRow ? onRow(item, index) : null;
          return (
            <RowSelectionLayout
              key={`${item[rowKey]}`}
              rowSelection={rowSelection}
              listValues={listValues}
              itemValue={item}
              rowKey={rowKey}
              onEvents={onEvents}
            >
              <Item key={`${item[rowKey]}`} {...(onEvents || {})} arrow={false} style={{ width: '100%' }}>
                <div className={styles['item-wrap']}>
                  <div className={styles['item-top-wrap']}>
                    <div className={styles['item-title-wrap']}>
                      <div className={styles['item-icon-wrap']} />
                      <span style={{ width: '50vw' }} >
                        <SPField
                          rowIndex={index}
                          from="form"
                          name={[showColumns.titleColums.dataIndex]}
                          render={showColumns.titleColums.render}
                          valueType={showColumns.titleColums.valueType}
                          formItemProps={showColumns.titleColums.formItemProps}
                          fieldProps={showColumns.titleColums.fieldProps}
                          style={{ marginBottom: 0 }}
                          formValue={item}
                          mode="read"
                        />
                      </span>
                    </div>
                    <div
                      className={styles['item-right-light']}
                      onClick={(e) => {
                        e.stopPropagation();
                        setOptionState({
                          visible: true,
                          ele: mbOptionColums?.render(null, item, index),
                        });
                      }}
                    >
                      <img
                        src={optionImages}
                        width={30}
                      />
                    </div>
                  </div>
                  <div className={styles['item-content-wrap']}>
                    <div className={styles['item-content']}>{contentItems}</div>
                    <div className={styles['item-arrow']}>
                      <RightOutlined
                        style={{ fontSize: '20px' }}
                        onClick={(e) => {
                          e.stopPropagation();
                          clickRowIndex.current = index;
                          if (!isEdit) {
                            setViewPoupupVisible(true);
                            return;
                          }
                          setEditPopupVisible(true);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Item>
            </RowSelectionLayout>
          );
        })}
      </RowSelectionBox>
      <Popup
        visible={editPopupVisible}
        position="right"
        bodyStyle={{ width: '100vw' }}
        destroyOnClose
      >
        <div className={styles['popup-box']}>
          <div className={styles['popup-spForm-box']}>
            <SPForm
              ref={rowFormRef}
              defaultValue={Object.values(listValue).flat()?.[clickRowIndex.current]}
              columns={mergeColumns}
              submitter={false}
              isMobile
            />
          </div>
          {isEdit && (
          <div
            className={styles['popup-option-tools']}
          >
            <div
              className={styles['option-btn']}
              onClick={() => {
                setEditPopupVisible(false);
              }}
            >取消
            </div>
            <div
              className={styles['option-btn']}
              style={{ color: '#0064CE' }}
              onClick={() => changeRow()}
            >确定
            </div>
          </div>
          )}
          <div className={styles['popup-safe-div']} />
        </div>
      </Popup>
      <Popup
        visible={viewPoupupVisible}
        onMaskClick={() => {
          setViewPoupupVisible(false);
        }}
        style={{ zIndex: 1800 }}
        destroyOnClose
      >
        <div style={{ height: '60vh', overflowY: 'scroll' }}>
          <ItemView
            value={Object.values(listValue).flat()?.[clickRowIndex.current]}
            columns={mergeColumns}
          />
        </div>
      </Popup>
      <CenterPopup
        visible={optionState.visible}
        onMaskClick={() => {
          setOptionState({ visible: false, ele: null });
        }}
        destroyOnClose
      >
        <div className={styles['pop-item-wrap']}>
          {optionState.ele}
        </div>
      </CenterPopup>
    </>
  );
};
